import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { StaticImage } from "gatsby-plugin-image"
import { FaHeart } from "react-icons/fa"
import { IoEarthSharp } from "react-icons/io5"

const AstralVibrationNumber = () => {
  const {
    setFirstName,
    selectedSign,
    firstName,
    lastName,
    emailAddress,
    mainAudio,
    setCurrentAudioStage,
    setCurrentStep,
    audioEnded,
    currentAudioStage,
    setAudioEnded,
    currentAudioTime,
    setCurrentAudioTime,
  } = useSiteContext()

  const [disappearing, setDisappearing] = useState(false)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [isNumberChanging, setIsNumberChanging] = useState(false)
  const [renderedCharacters, setRenderedCharacters] = useState([])
  const [earthlyNumber, setEarthlyNumber] = useState(0)
  const [flashNumbers, setFlashNumbers] = useState(false)
  const [transformStyle, setTransformStyle] = useState([])
  const [stage, setStage] = useState(1)
  const [hasStartedCalculation, setHasStartedCalculation] = useState(false)
  let pNumber = -1

  function isAlphabetic(char) {
    return /^[A-Za-z]$/.test(char)
  }

  useEffect(() => {
    // document.body.style.overflow = "hidden"

    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

    if (isFirefox) {
      // Custom smooth scroll for Firefox
      const smoothScrollToTop = () => {
        let currentScroll = window.scrollY
        if (currentScroll > 0) {
          window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
          requestAnimationFrame(smoothScrollToTop)
        }
      }
      requestAnimationFrame(smoothScrollToTop)
    } else {
      // Native smooth scroll for Chrome, Safari, and others
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

    let characterArray = firstName.split("")
    characterArray.push("~")
    lastName.split("").map(char => characterArray.push(char))

    const delay = 4500 / characterArray.length
    let eNumber = 0

    characterArray.forEach((char, index) => {
      if (char !== "~") {
        eNumber += isAlphabetic(char)
          ? char.toUpperCase().charCodeAt(0) - 64
          : 0
      }

      setTimeout(() => {
        setRenderedCharacters(prevChars => [...prevChars, char])
      }, index * delay)
    })

    setEarthlyNumber(eNumber)

    setTimeout(() => {
      const eles = document.querySelectorAll(".letters")
      eles.forEach(ele => {
        ele.classList.add("opacity-0")
      })
    }, 8000)

    setTimeout(() => {
      const eles = document.querySelectorAll(".numerals")
      let ts = []

      eles.forEach(ele => {
        const rect = ele.getBoundingClientRect()
        const elementMidX = rect.left + rect.width / 2
        const elementMidY = rect.top + rect.height / 2

        const targetElement = document.getElementById("targetEl")
        const targetRect = targetElement.getBoundingClientRect()

        const targetMidX = targetRect.left + targetRect.width / 2
        const targetMidY = targetRect.top + targetRect.height / 2

        // // Adjust offsets based on the quadrant of the element
        // if (elementMidX < viewportMidX) {
        //   offsetXFromMidpoint = Math.abs(offsetXFromMidpoint)
        // } else {
        //   offsetXFromMidpoint = -Math.abs(offsetXFromMidpoint)
        // }

        // if (elementMidY < viewportMidY) {
        //   offsetYFromMidpoint = Math.abs(offsetYFromMidpoint)
        // } else {
        //   offsetYFromMidpoint = -Math.abs(offsetYFromMidpoint)
        // }

        const offsetXFromMidpoint = targetMidX - elementMidX
        const offsetYFromMidpoint = targetMidY - elementMidY

        ts.push(`translate(${offsetXFromMidpoint}px, ${offsetYFromMidpoint}px)`)
      })
      setTransformStyle(ts)
      setIsTransitioning(true)
      setTimeout(() => {
        setStage(2)
        setIsTransitioning(false)
      }, 1500)
    }, 11000)
  }, [])

  const doAdd = (targetNum, delay, en) => {
    const wait = delay / (targetNum - en)
    const interval = setInterval(() => {
      setEarthlyNumber(earthlyNumber => earthlyNumber + 1)
      en++
      if (en === targetNum) {
        setIsNumberChanging(false)
        clearInterval(interval)
      }
    }, wait)
  }

  const doSubtract = (targetNum, delay, en) => {
    const wait = delay / (en - targetNum)
    const interval = setInterval(() => {
      setEarthlyNumber(earthlyNumber => earthlyNumber - 1)
      en--
      if (en === targetNum) {
        setIsNumberChanging(false)
        clearInterval(interval)
      }
    }, wait)
  }

  useEffect(() => {
    if (currentAudioStage === "convert-to-astral" && !hasStartedCalculation) {
      if (currentAudioTime > 0) {
        setHasStartedCalculation(true)
        let times2 = earthlyNumber * 2
        let add12 = earthlyNumber * 2 + 12
        let divide2 = (earthlyNumber * 2 + 12) / 2

        setTimeout(() => {
          setIsNumberChanging(true)
          doAdd(times2, 4000, earthlyNumber)
        }, 5800)
        setTimeout(() => {
          setIsNumberChanging(true)
          doAdd(add12, 2500, times2)
        }, 11000)
        setTimeout(() => {
          setIsNumberChanging(true)
          doSubtract(divide2, 2000, add12)
        }, 16000)
        setTimeout(() => {
          setIsNumberChanging(true)
          doSubtract(6, 6000, divide2)
        }, 20500)
      }
    }
  }, [currentAudioTime])

  useEffect(() => {
    if (audioEnded) {
      // Go to next clip
      const filename = mainAudio.src.split("/").pop()
      mainAudio.pause()

      if (currentAudioStage === "wonderful") {
        setCurrentAudioTime(0)
        setCurrentAudioStage("convert-to-astral")
        mainAudio.src = "/audio/convert-to-astral.mp3"
        mainAudio.play()
        setAudioEnded(false)
      } else {
        setDisappearing(true)
        setTimeout(() => {
          setCurrentAudioStage("number-6")
          mainAudio.src = `/audio/number-6.mp3`
          mainAudio.play()
          setAudioEnded(false)
          setCurrentStep(9)
        }, 700)
      }
    }
  }, [audioEnded])

  return (
    <>
      {/* Preload images */}
      {/* <div className="hidden">
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/earthly-number.png"
          placeholder="blurred"
          alt={selectedSign}
          className="hidden"
        />
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/earth-min.png"
          placeholder="blurred"
          alt={"Earth"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          loading={"eager"}
          src="../images/astral-number.png"
          placeholder="blurred"
          alt={"Astral Vibration Number"}
          className="hidden"
        />
      </div> */}
      {stage === 2 && (
        <>
          <div
            className={`text-center fade-in ${
              disappearing ? "disappear transition duration-1000" : ""
            }`}
          >
            <h1 className="text-2xl font-bold text-white md:text-4xl">
              Your Earthly{" "}
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/earth-min.png"
                placeholder="blurred"
                alt="Earth"
                className="inline-block w-7 h-7 md:w-10 md:h-10 translate-y-0.5"
              />
              <br />
              Vibration Number
            </h1>

            <div className="relative flex items-center justify-center mt-6">
              {/* Container for images and number */}
              <div className="relative">
                {/* Zodiac Glow Image (background) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/earthly-number.png"
                  placeholder="blurred"
                  alt={selectedSign}
                  className="w-64 h-64 md:w-96 md:h-96 zodiac-glow"
                  style={{
                    position: "absolute",
                    zIndex: 1,
                  }}
                />

                {/* Slow Pulse Image (foreground) */}
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/earthly-number.png"
                  placeholder="blurred"
                  alt={selectedSign}
                  className="w-64 h-64 md:w-96 md:h-96 slow-pulse"
                  style={{
                    position: "relative",
                    zIndex: 2,
                  }}
                />

                {/* Earthly Number Text */}
                <div
                  className="absolute z-20 flex items-center justify-center px-4 py-2 overflow-hidden text-6xl font-bold text-white bg-black bg-opacity-50 rounded-md fade-in-slow md:text-8xl"
                  style={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <div>{earthlyNumber}</div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {stage === 1 && (
        <>
          <div id="targetEl" className="fixed left-1/2 top-1/2" />
          <div
            className={`text-center mt-0 sm:mt-12 fade-in flex gap-y-5 sm:gap-y-10 justify-center flex-wrap ${
              isTransitioning ? "disappear transition duration-[1500ms]" : ""
            }`}
          >
            {/* Render each character */}
            {renderedCharacters.map((char, index) => {
              if (char !== "~") pNumber += 1

              return char === "~" ? (
                <div key={index} className="w-full" />
              ) : (
                <div
                  key={index}
                  style={{
                    flex: "0 0 calc(12.5%)", // Maximum of 8 columns per row
                  }}
                >
                  <div className="flex flex-col fade-in-slow">
                    <div className="relative">
                      <StaticImage
                        quality={95}
                        loading={"eager"}
                        src="../images/scroll.png"
                        placeholder="blurred"
                        alt=""
                        className={`w-full h-full max-h-24 max-w-16 letters transition duration-[3000ms]`}
                      />
                      <p className="absolute text-2xl font-extrabold text-black transition duration-[3000ms] -translate-x-1/2 -translate-y-1/2 letters sm:text-3xl left-1/2 top-1/2">
                        {char.toUpperCase()}
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          transform: transformStyle[pNumber],
                        }}
                        className={`numerals transition duration-[1500ms] text-xl font-bold text-white sm:text-2xl fade-in-numeral`}
                      >
                        {isAlphabetic(char)
                          ? char.toUpperCase().charCodeAt(0) - 64
                          : "0"}
                      </p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </>
      )}
    </>
  )
}

export default AstralVibrationNumber
